import React, {useCallback, useLayoutEffect, useRef, useState} from "react";
import "./TabPane.css";
import {Button} from "../Button/Button";
import {buildClassName, checkNestedExists} from "../../../utilities/helperFunctions";


function TabPane(props) {

    const {
        labels,
        children,
        force,
        ...attr
    } = props;


    const [tabIndex, setTabIndex] = useState(0);
    const [isTabListFocused, setIsTabListFocused] = useState(false);
    const tabListRef = useRef();
    const contentRef = useRef();

    const selectTab = useCallback(event => {
        setTabIndex(event.currentTarget.value);
    }, []);

    useLayoutEffect(() => {
        if (children[tabIndex] == null && children.length > 0) {
            setTabIndex(0);
        }
    }, [children]);

    useLayoutEffect(() => {
        if (checkNestedExists(force, 'tabIndex')) {
            setTabIndex(force.tabIndex);
        }
    }, [force]);

    useLayoutEffect(() => {
        contentRef.current?.focus();
    }, [tabIndex])


    const blurTimeout = useRef();
    const onTabListFocusIn = useCallback(event => {
        clearTimeout(blurTimeout.current);
        if (!isTabListFocused) {
            setIsTabListFocused(true);
            const activeButton = tabListRef.current.querySelectorAll('[role="tab"][aria-selected="true"]')[0];
            activeButton?.focus();
        }
    }, [isTabListFocused]);

    const onTabListBlur = useCallback(event => {
        clearTimeout(blurTimeout.current);
        blurTimeout.current = setTimeout(() => {
            setIsTabListFocused(false);
            blurTimeout.current = null;
        }, 250);
    }, []);


    return (
        <section className="tab-pane" {...attr} onBlur={onTabListBlur}>
            <section role="tablist" className="tab-pane__tab-list" tabIndex={-1}
                ref={tabListRef} onFocus={onTabListFocusIn}
            >

                {labels.map((label, index) => {
                    const isSelected = index == tabIndex;
                    const tabClassName = buildClassName(
                        'tab-pane__tab',
                        isSelected && 'is-selected'
                    );

                    return (
                        <Button key={index} role="tab" className={tabClassName}
                            label={label} value={index} onClick={selectTab} isBold={isSelected}
                            aria-selected={isSelected} aria-controls={'tabPanePanel'}
                        />
                    )
                })}
            </section>

            <section role="tabpanel" tabIndex={-1} id="tabPanePanel"
                ref={contentRef} className="tab-pane__content">
                {children[tabIndex]}
            </section>
        </section>
    )
}

export default TabPane;
